import SetItemDepthCommand from '../command/setItemDepthCommand';
import LengthUnitField from './lengthUnitField';

/**
 * @class DepthField
 */
export default class DepthField extends LengthUnitField {
    type = 'depth';
    supports = 'supportsDepth';

    /**
     * Update field with item value.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        this.setValue(item.get('depth'));
    }

    /**
     * Update item with field value.
     *
     * @param {ItemInterface} item
     */
    updateItem(item) {
        const depth = this.getValue();
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();

        this.assertItemValue(item, 'depth', depth);

        const command = new SetItemDepthCommand(
            item,
            depth,
        );

        history.addAndExecuteCommand(command);
    }

    /**
     * Update item with field value and apply a difference.
     *
     * @param {ItemInterface} item
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const depth = this.getValue() + difference;
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();

        this.assertItemValue(item, 'depth', depth);

        const command = new SetItemDepthCommand(
            item,
            depth,
        );

        history.addAndExecuteCommand(command);
    }

    /**
     * Check if item NOT supports depth dropdowns.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        const supportFlag = this.supports;

        return selectionLength
            && item
            && supportFlag && item[supportFlag]
            && !item.supportedDepths;
    }
}
